import React, { forwardRef } from 'react';
import uuid from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid.v4();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M10.5 1.5L10.5 19.29L3.96005 13.845C3.65372 13.5904 3.2588 13.4679 2.86216 13.5045C2.46552 13.541 2.09966 13.7337 1.84505 14.04C1.59044 14.3463 1.46795 14.7412 1.50452 15.1379C1.54109 15.5345 1.73372 15.9004 2.04005 16.155L11.04 23.655C11.1116 23.7055 11.1868 23.7506 11.265 23.79C11.34 23.79 11.385 23.79 11.46 23.895C11.632 23.963 11.8151 23.9986 12 24C12.185 23.9986 12.3681 23.963 12.54 23.895C12.615 23.895 12.66 23.895 12.735 23.79C12.8133 23.7506 12.8885 23.7055 12.96 23.655L21.96 16.155C22.1294 16.014 22.2655 15.8374 22.3589 15.6377C22.4522 15.4381 22.5004 15.2204 22.5 15C22.5007 14.6495 22.3787 14.3099 22.155 14.04C22.0291 13.8881 21.8745 13.7626 21.7 13.6705C21.5254 13.5785 21.3345 13.5218 21.138 13.5037C20.9415 13.4856 20.7434 13.5064 20.555 13.565C20.3666 13.6235 20.1916 13.7187 20.04 13.845L13.5 19.29L13.5 1.5C13.5 1.10217 13.342 0.720644 13.0607 0.439339C12.7794 0.158034 12.3979 1.29978e-07 12 1.25234e-07C11.6022 1.2049e-07 11.2207 0.158033 10.9394 0.439339C10.6581 0.720644 10.5 1.10217 10.5 1.5Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
